import React, { Component } from "react"
import Svg from "../_svgs/svg"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as endpoints from "../../api/endpoints"
import { isMobile } from "react-device-detect"

export default class HandlingAccordion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      airlines: [],
      airlinesExpanded: false,
      prevHeight: undefined,
      showMoreButton: false,
    }

    if (props.showAirlines) this.getAirlines(this.props.handlingCompany, this.props.language)

    this.accordionRef = React.createRef()
  }

  componentDidMount() {
    if (window.location.hash?.replace("#", "") === this.props.handlingCompany) {
      // waits until paint is done
      requestAnimationFrame(() => {
        this.openAccordionFromAnchor()
      })
    }
  }

  openAccordionFromAnchor = () => {
    const accordion = document.getElementById(this.props.handlingCompany)
    const accordionTrigger = accordion.querySelector(".accordion-trigger")
    if (accordionTrigger) {
      this.showHideContent(accordionTrigger, ".contentWrapper")
    }
  }

  handleAccordion = (event, classname) => {
    let elem = event.currentTarget
    this.showHideContent(elem, classname)
  }

  showHideContent = (elem, classname) => {
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  handleAirlineAccordion = (event) => {
    let elem = event.currentTarget
    let airlines = elem.parentElement.querySelector(".airlines")
    if (airlines) {
      let contentWrapper = elem.parentElement
      if (contentWrapper) {
        elem.__toggle = !elem.__toggle
        if (elem.__toggle) {
          const prevHeight = contentWrapper.clientHeight
          airlines.style.overflow = null
          contentWrapper.style.height = contentWrapper.scrollHeight + "px"
          let state = { airlinesExpanded: true }
          if (!this.state.prevHeight) {
            state["prevHeight"] = prevHeight
          }
          this.setState(state)
        } else {
          airlines.style.overflow = "hidden"
          contentWrapper.style.height = this.state.prevHeight + "px"
          this.setState({ airlinesExpanded: false })
        }
      }
    }
  }

  getAirlines = async (handlingCompany, language) => {
    const data = { handlingCompany: handlingCompany ?? "", language: language }
    const response = await endpoints.getAirlinesFromHandlingCompany(data)
    let airlines = []
    if (response && response.data) {
      airlines = response.data
    }
    this.setState({ airlines: airlines }, () => {
      requestAnimationFrame(() => {
        this.showButton()
      })

      // adjust accordion height to airlines
      const accordion = this.accordionRef.current
      let elem = accordion.querySelector(".accordion-trigger")
      let target = accordion.querySelector(".contentWrapper")
      if (elem.__toggle && elem.classList.contains("is-active")) {
        target.style.height = target.scrollHeight + "px"
        elem.classList.add("is-active")
      }
    })
  }

  showButton = () => {
    // if company info scrollheight < headline + list scrollheight, show button
    const accordion = this.accordionRef.current
    const companyInfo = accordion.querySelector(".company-info")
    const airlines = accordion.querySelector(".airlines")
    const airlinesHeadline = airlines.querySelector(".headline")
    const airlinesList = airlines.querySelector(".list")

    const infoHeight = companyInfo.scrollHeight
    const airlinesHeight = airlinesHeadline.scrollHeight + airlinesList.scrollHeight
    if (window.innerWidth < 768) {
      if (airlinesHeight > 230) this.setState({ showMoreButton: true })
    } else {
      if (airlinesHeight > infoHeight) this.setState({ showMoreButton: true })
    }
  }

  render() {
    const airlinesIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.airlinesIcon)
    const style = this.state.showMoreButton ? { paddingBottom: "60px" } : {}

    return (
      <div ref={this.accordionRef} className="accordionitem" id={this.props.handlingCompany}>
        <h4 className="accordion-trigger" onClick={(e) => this.handleAccordion(e, ".contentWrapper")}>
          {this.props.headline}
        </h4>
        <div className="contentWrapper show-hide">
          <div className="top-border"></div>
          <div className="content">
            <div className="company-info">
              {this.props.contentArea && this.props.contentArea.length > 0
                ? this.props.contentArea.map((item, index) => {
                    const icon = SelectionFactoryHelper.getFromSelectionFactory(item.icon)
                    return (
                      <div className="info-item" key={`infoItem${index}`}>
                        {item.iconUpload ? (
                          <div className="icon">
                            <img src={item.iconUpload} alt="icon" />
                          </div>
                        ) : icon ? (
                          <Svg iconName={icon} fillColor={"#071143"} />
                        ) : (
                          ""
                        )}
                        <span>{ReactHtmlParser(item.richText)}</span>
                      </div>
                    )
                  })
                : ""}
            </div>
            {this.props.showAirlines ? (
              <div className="airlines" style={{ overflow: "hidden" }}>
                <div className="headline">
                  {this.props.airlinesIconUpload ? (
                    <div className="icon">
                      <img src={this.props.airlinesIconUpload} alt="icon" />
                    </div>
                  ) : airlinesIcon ? (
                    <Svg iconName={airlinesIcon} fillColor={"#071143"} />
                  ) : (
                    ""
                  )}
                  <h5>{this.props.airlinesHeadline}</h5>
                </div>
                <ul className="list" style={style}>
                  {this.state.airlines && this.state.airlines.length > 0
                    ? this.state.airlines.map((airline) => {
                        return (
                          <li key={airline.AirlineName_s}>
                            <a href={airline.PageUrl_s}>
                              {isMobile && airline.AirlineMobileName_s ? airline.AirlineMobileName_s : airline.AirlineName_s}
                            </a>
                          </li>
                        )
                      })
                    : ""}
                </ul>
              </div>
            ) : (
              <div className="airlines">
                <span className="rich">{ReactHtmlParser(this.props.airlinesRichText)}</span>
              </div>
            )}
          </div>
          {this.props.showAirlines && this.state.showMoreButton ? (
            <div className={`viewmore ${this.state.airlinesExpanded ? "open" : ""}`} onClick={(e) => this.handleAirlineAccordion(e)}>
              {this.state.airlinesExpanded ? (
                <Svg iconName="minus_sign" renderContainer={false} />
              ) : (
                <Svg iconName="plus_sign" renderContainer={false} />
              )}{" "}
              {this.state.airlinesExpanded ? this.props.airlinesViewLess || "Vis færre" : this.props.airlinesViewMore || "Vis flere"}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
